import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CRow,
} from '@coreui/react';

import CIcon from '@coreui/icons-react';
import { useDispatch } from 'react-redux';
import everyangleLogo from 'app/assets/images/everyangle-logo-blue.png';
import ApplyChangeEmailAction from 'user-profile/actions/ApplyChangeEmailAction';

const InvalidHashMessage = ({ handleGoToLoginBtn }) => (
  <>
    <h2 className="text-center pb-2">
      Sorry, this link is expired or invalid.{' '}
    </h2>

    <p className="text-center pb-4">
      It's also possible that you've already changed your email using this link,
      or it’s been more than 24 hours since we sent the link to you.
    </p>
    <p className="text-center">
      <CButton color="link" className="px-0" onClick={handleGoToLoginBtn}>
        Go to Login Page
      </CButton>
    </p>
  </>
);

const SuccessPasswordResetMessage = ({ handleGoToLoginBtn }) => (
  <>
    <h2 className="text-center pb-2">New email has been verified and updated</h2>
    <p className="text-center">
      <CButton color="link" className="px-0" onClick={handleGoToLoginBtn}>
        Go to login page
      </CButton>
    </p>
  </>
);
const ChangeEmailConfirmationPage = () => {
  const { email, token } = useParams();
  const [currentStep, setCurrentStep] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleGoToLoginBtn = () => {
    history.push('/customer/profile');
  };
  useEffect(() => {
    const onSuccess = () => {
      setCurrentStep(1);
    };
    const onError = () => {
      setCurrentStep(2);
    };

    dispatch(ApplyChangeEmailAction(email, token, onSuccess, onError));
  }, []);

  /* Determinate current showing component */
  let CurrentComponent = ChangeEmailConfirmationPage;
  if (currentStep === 1) CurrentComponent = SuccessPasswordResetMessage;
  else if (currentStep === 2) CurrentComponent = InvalidHashMessage;

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol className="col-12" lg="5">
            <div className="text-center mb-3">
              <CIcon
                className="justify-content-center"
                src={everyangleLogo}
                height={90}
              />
            </div>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  {currentStep === 0 ? (
                    <>
                      <div className="spinner-border spinner-border-sm ml-2" />{' '}
                      Loading...
                    </>
                  ) : (
                    <CurrentComponent handleGoToLoginBtn={handleGoToLoginBtn} />
                  )}
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default ChangeEmailConfirmationPage;
